import { ColumnDef } from "@tanstack/react-table";
import { formatDate } from "../../../helpers/appHelpers";

// Type definitions
interface AnnouncementRow {
	id: number;
	title: string;
	body: string;
	publishDate: string;
	public: boolean;
	active: boolean;
	createdAt?: string;
	modifiedAt?: string;
}

// ========== Announcements Columns ==========
export const announcementsColumns: ColumnDef<AnnouncementRow>[] = [
	{
		id: "title",
		accessorKey: "title",
		header: "Title",
		size: 250,
	},
	{
		id: "body",
		accessorKey: "body",
		header: "Body",
		size: 400,
	},
	{
		id: "publishDate",
		accessorKey: "publishDate",
		header: "Publish Date",
		size: 200,
		cell: ({ row }) => formatDate(row.original.publishDate),
	},
	{
		id: "public",
		accessorKey: "public",
		header: "Public",
		size: 140,
		cell: ({ row }) => (row.original.public ? "Yes" : "No"),
	},
	{
		id: "active",
		accessorKey: "active",
		header: "Active",
		size: 140,
		cell: ({ row }) => (row.original.active ? "Yes" : "No"),
	},
];

export const announcementsColumnVisibility: Record<string, boolean> = {
	title: true,
	body: true,
	publishDate: true,
	public: true,
	active: true,
};
